module.exports = __webpack_public_path__ + "static/media/summary.c03702d4.jpg";